import React, { Component } from 'react'
import { connect } from 'react-redux'
import Panel from 'react-bootstrap/lib/Panel'
import Edit from 'react-icons/lib/md/mode-edit'
import Loading from 'bisu-react-loading'

import { getListIndexById } from 'utils/helpers'

import Details from './details'
import { fetchPresets } from './actions'

class FeesPresetsShow extends Component {

  _editPreset = () => {
    this.props.onForm(this.props.__item)
  }

  render() {
    const { __items, __item, __pending, params } = this.props
    if (!__items) {
      return <Loading />
    }

    const header = (
      <div className="row">
        <div className="col-sm-6">{__item.get('code')}</div>
        <div className="col-sm-6 text-right">
          <button type="button" onClick={this._editPreset} className="btn-icon btn-inline"><Edit /></button>
        </div>
      </div>
    )

    return (
      <div>
        <Panel header={header}>
          <Details id={params.id} items={__items} pending={__pending} />
        </Panel>
      </div>
    )
  }
}

FeesPresetsShow.onEnter = (store) => () => store.dispatch(fetchPresets())

function mapStateToProps(state, ownProps) {
  const index = getListIndexById(Number(ownProps.params.id), state.preset.get('list'))
  return {
    __items: state.preset.getIn(['items', ownProps.params.id]),
    __item: state.preset.getIn(['list', index]),
    __pending: state.preset.get('pending'),
  }
}
export default connect(mapStateToProps)(FeesPresetsShow)



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/show.js